export default __webpack_public_path__ + "static/media/13@3x.0e8d179d.png";